import { useCallback, useMemo } from 'react';
import { Row } from 'react-table';
import { Button, Table } from '@nbirl/nbi-common-ui-libs';

import { useBulkUploads } from '../../../../shared/context';
import { BulkUploadActionType } from '../../../../shared/enum';
import { useQueryParams } from '../../../../shared/hooks';
import { TableQueryState, UploadType } from '../../../../shared/models';
import { getUploadListColumns } from '../constants';

export const QueuedSection = () => {
  const [tableState] = useQueryParams<TableQueryState>({
    pageSize: 50,
    pageIndex: 0,
    sortBy: '',
  });
  const {
    dispatch,
    state: { queued },
  } = useBulkUploads();

  const renderActionsColumn = useCallback(
    ({ row }: { row: Row<UploadType> }) => (
      <div className="flex justify-end">
        <Button
          variant="outline"
          size="sm"
          onClick={() =>
            dispatch({
              type: BulkUploadActionType.REMOVE_UPLOAD,
              payload: { id: row.original.id, collection: 'queued' },
            })
          }
        >
          Cancel
        </Button>
      </div>
    ),
    [dispatch]
  );

  const columns = useMemo(
    () => getUploadListColumns(renderActionsColumn),
    [renderActionsColumn]
  );

  return (
    <div className="mb-6" data-testid="queued-section">
      <div className="flex justify-between items-center mb-4 pr-6">
        <h4 className="font-medium">Queued</h4>
        <Button
          variant="outline"
          size="sm"
          onClick={() =>
            dispatch({ type: BulkUploadActionType.REMOVE_QUEUED_UPLOADS })
          }
        >
          Cancel All
        </Button>
      </div>

      <Table
        columns={columns}
        data={queued}
        disableSortRemove
        hasRowDividers
        showPagination={true}
        totalCount={queued.length}
        {...tableState}
      />
    </div>
  );
};
